import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state:{
    setNavData: sessionStorage.getItem('a_id') || '',
    systemSetUp:[],
  },
  mutations:{
    setNavData(state,setNavData){
      state.setNavData = setNavData
    },
    systemSetUp(state,systemSetUp){
      state.systemSetUp = systemSetUp
    }
  },
  actions: {

  },
  modules: {},
})



// WEBPACK FOOTER //
// ./src/store/index.js